import React from 'react'
import { useNavigate } from 'react-router-dom'
import DataGridWithSearchV2 from 'components/generic/datagrid/DataGridWithSearchV2'

const getColumns = () => [
  {
    field: 'plateNumber',
    headerName: 'Plate #',
    flex: 1,
  },
  {
    field: 'plateState',
    headerName: 'Plate State',
    flex: 1,
  },
  {
    field: 'make',
    headerName: 'Make',
    flex: 1,
  },
  {
    field: 'model',
    headerName: 'Model',
    flex: 1,
  },
]

const VehicleGrid = props => {
  const navigate = useNavigate()
  return <DataGridWithSearchV2 {...props} columns={getColumns(navigate)} disableSelectionOnClick hideFooter />
}

VehicleGrid.propTypes = DataGridWithSearchV2.propTypes

VehicleGrid.defaultProps = DataGridWithSearchV2.defaultProps

export default VehicleGrid
